import { PropsWithChildren } from 'react'

import { UserRole as DDERole } from '@img-arena/consoles-api-dde'
import { UserRole as DGERole } from '@img-arena/consoles-api-streaming'
import { useAuthStore } from '@/stores/useAuthStore'

type Props = {
  roles: DDERole[] | DGERole[]
}

const RoleDependent = (props: PropsWithChildren<Props>) => {
  const userRole = useAuthStore((state) => state.userRole)
  if (!userRole || !props.roles.map(String).includes(userRole)) return null
  return props.children
}

export default RoleDependent
